import { render } from "./AddContainer.vue?vue&type=template&id=00fef7ae"
import script from "./AddContainer.vue?vue&type=script&lang=js"
export * from "./AddContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__